var startFromSlide = window.innerWidth <= 767 ? 1 : 0;
document.addEventListener("DOMContentLoaded", () => {
  // Login and Register Password
  document
    .querySelectorAll(".ht_password_toggle")
    .forEach(function (toggleIcon) {
      toggleIcon.addEventListener("click", function () {
        const wrapper = toggleIcon.closest(".ht_password_toggle_wrapper");
        const input = wrapper.querySelector(
          "input[type='password'], input[type='text']"
        );
        const openIcon = toggleIcon.querySelector(".ht_password_toggle_open");
        const closeIcon = toggleIcon.querySelector(".ht_password_toggle_close");

        const isPasswordVisible = input.type === "text";
        input.type = isPasswordVisible ? "password" : "text";
        openIcon.style.display = isPasswordVisible ? "none" : "grid";
        closeIcon.style.display = isPasswordVisible ? "grid" : "none";
      });
    });

  // Product 360

  document.querySelectorAll(".ht_product_360_plus").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const overlay = document.querySelector(".ht_product_360_mobile_overlay");
      if (overlay) {
        overlay.classList.add("active");
      }
    });
  });

  const overlay = document.querySelector(".ht_product_360_mobile_overlay");
  if (overlay) {
    overlay.addEventListener("click", function () {
      overlay.classList.remove("active");
    });
  }

  setTimeout(function () {
    // Get the Swiper instance from the DOM element
    const swiperEl = document.querySelector(".tt-card-list");

    if (swiperEl) {
      // Access Swiper instance from the element
      const swiperInstance = swiperEl?.swiper;

      if (swiperInstance) {
        swiperInstance.params.slidesPerView = 3.5; // Set to desired number

        // Update breakpoints
        swiperInstance.params.breakpoints = {
          768: {
            slidesPerView: 2.5,
          },
          1024: {
            slidesPerView: 3.5,
          },
        };

        // Stop autoplay if it's running
        if (swiperInstance.autoplay) {
          swiperInstance.autoplay.stop();
          swiperInstance.params.autoplay = false;
        }
        swiperInstance.update(); // Apply the change
      } else {
        console.warn("Swiper instance not found for .tt-card-list");
      }
    }
  }, 2000);

  let isScrolling;
  const footer = document.getElementById(
    "shopify-section-sections--24838832587037__footer_filler_LHbqn7"
  );

  window.addEventListener("scroll", function () {
    if(!footer){
      return
    }
    // Add z-index -1 when scrolling starts
    footer.style.setProperty("z-index", "-1", "important");

    // Clear our timeout throughout the scroll
    clearTimeout(isScrolling);

    // Set a timeout to run after scrolling ends
    isScrolling = setTimeout(function () {
      // Remove z-index when scrolling stops
      footer.style.removeProperty("z-index");
    }, 50); // 150ms after scroll stops
  });
  var filler_swiper = new Swiper(".ht_filler_slider", {
    slidesPerView: "auto",
    spaceBetween: 24,
    loop: true,
    speed: 5000, // duration of transition (higher = slower, smoother)
    autoplay: {
      delay: 0, // no delay between transitions
      disableOnInteraction: false,
    },
  });

  // Product Best Paired Swiper
  var ht_product_best_paired_swiper = new Swiper(
    ".ht_product_best_paired_swiper",
    {
      slidesPerView: 1,
      spaceBetween: 50,
      navigation: {
        nextEl: ".ht_product_best_paired_swiper_btn .swiper_icon_right",
        prevEl: ".ht_product_best_paired_swiper_btn .swiper_icon_left",
      },
      breakpoints: {
        520: {
          slidesPerView: 2.5,
        },
        1180: {
          slidesPerView: 3.5,
        },
      },
    }
  );

  // Product Taste/Texture Swiper

  var ht_product_taste_texture_image_swiper = new Swiper(
    ".ht_product_taste_texture_image_swiper",
    {
      initialSlide: startFromSlide,
      slidesPerView: 1,
      slidesPerGroup: 1,
      parallax: true,
      speed: 600,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      loop: true,
      navigation: {
        nextEl: ".ht_product_taste_texture_btn .swiper_icon_right",
        prevEl: ".ht_product_taste_texture_btn .swiper_icon_left",
      },
      allowTouchMove: false,
      simulateTouch: false,
      grabCursor: false,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 3,
        },
      },
      on: {
        slideChangeTransitionStart: function () {
          // Reset all slide-inner elements
          gsap.set(".swiper-slide .ht_product_taste_texture_content_slide", {
            y: 80,
            opacity: 0,
          });
        },
        slideChangeTransitionEnd: function () {
          // Animate only active slides (visible ones)
          let activeSlides = document.querySelectorAll(
            ".ht_product_taste_texture_content_swiper .swiper-slide-active .ht_product_taste_texture_content_slide, " +
              ".ht_product_taste_texture_content_swiper .swiper-slide-duplicate-active .ht_product_taste_texture_content_slide"
          );

          gsap.to(activeSlides, {
            duration: 0.4,
            y: 0,
            opacity: 1,
            ease: "power3.out",
            stagger: 0.1,
          });
        },
      },
    }
  );

  var ht_product_taste_texture_content_swiper = new Swiper(
    ".ht_product_taste_texture_content_swiper",
    {
      slidesPerView: 1,
      loop: true,
      allowTouchMove: false,
      simulateTouch: false,
      grabCursor: false,
      navigation: {
        nextEl: ".ht_product_taste_texture_btn .swiper_icon_right",
        prevEl: ".ht_product_taste_texture_btn .swiper_icon_left",
      },
    }
  );

  // Link them together
  // ht_product_taste_texture_image_swiper.controller.control =
  //   ht_product_taste_texture_content_swiper;
  // ht_product_taste_texture_content_swiper.controller.control =
  //   ht_product_taste_texture_image_swiper;

  // Product Detail Swiper

  var ht_product_details_swiper = new Swiper(".ht_product_details_swiper", {
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 3000,
    },
  });

  // var ht_banner_swiper = new Swiper(".ht_banner_swiper", {
  //   slidesPerView: 1,
  //   navigation: {
  //     nextEl: ".swiper_prev",
  //     prevEl: ".swiper_next",
  //   },
  // });

  // Product Listing Description Slider

  var ht_product_listing_feature_swiper = new Swiper(
    ".ht_product_listing_feature_swiper",
    {
      slidesPerView: 1,
      navigation: {
        nextEl: ".ht_product_listing_feature_swiper_btn .swiper_next",
        prevEl: ".ht_product_listing_feature_swiper_btn .swiper_prev",
      },
      parallax: true,
      speed: 800,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
    }
  );

  document.documentElement.style.setProperty(
    "--scrollbar-width",
    `${window.innerWidth - document.documentElement.clientWidth}px`
  );
  if (!gsap || !ScrollTrigger) {
    console.warn("GSAP or ScrollTrigger not loaded");
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  // Helper to animate SVG stroke drawing on scroll
  function animateStrokeDrawing(
    svgSelector,
    triggerSelector,
    start = "top 60%",
    end = "bottom top"
  ) {
    const svg = document.querySelector(svgSelector);
    if (!svg) return;

    const length = svg.getTotalLength();

    // Set initial strokeDasharray & strokeDashoffset
    gsap.set(svg, { strokeDasharray: length, strokeDashoffset: length });

    gsap.to(svg, {
      strokeDashoffset: 0,
      scrollTrigger: {
        trigger: triggerSelector,
        start,
        end,
        scrub: true,
      },
    });
  }

  // Animate all SVG lines with their respective triggers
  const svgAnimations = [
    {
      svg: ".why_us_line_svg",
      trigger: ".ht_why_us_main",
      start: "top bottom",
    },
    { svg: ".our_value_line_svg", trigger: ".ht_our_values" },
    { svg: ".our_product_line_svg", trigger: ".ht_our_products" },
    { svg: ".filler_slider_line_svg", trigger: ".ht_filler_slider_main" },
  ];

  svgAnimations.forEach(({ svg, trigger, start }) => {
    animateStrokeDrawing(svg, trigger, start || "top 60%", "bottom top");
  });

  // Fade out banner slider on scroll
  const htBannerSlider = document.querySelector(".ht_banner_slider");
  if (htBannerSlider) {
    gsap.fromTo(
      htBannerSlider,
      { opacity: 1 },
      {
        opacity: 0,
        scrollTrigger: {
          trigger: ".ht_banner_slider",
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
      }
    );
  }

  // Animate horizontal line width on scroll
  const htLineHorizontalWrapper = document.querySelector(
    ".ht_line_horizontal_wrapper"
  );
  if (htLineHorizontalWrapper) {
    gsap.fromTo(
      htLineHorizontalWrapper,
      { width: 0 },
      {
        width: "calc(100% - 33vw + 20px)",
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".ht_our_products",
          start: "top top",
          end: "bottom top",
          scrub: false,
        },
      }
    );
  }

  const grid = document.querySelector(".ht_product_journey_grid");
  const items = document.querySelectorAll(".ht_product_journey_img");
  // const line = grid.querySelector("::after"); // not accessible directly, so we animate it virtually
  const isMobile = window.innerWidth < 768;

  if (grid) {
    ScrollTrigger.create({
      trigger: ".ht_product_journey_grid", // Section to watch
      start: "top 80%", // When top of section hits 80% of viewport height
      once: true, // Only fire once
      onEnter: () => {
        document
          .querySelector(".ht_product_journey_grid")
          ?.classList.add("line_grow");
      },
    });

    // Step 1: Animate the line
    const gridWidth = grid.offsetWidth;
    const itemCount = items.length;
    const segment = gridWidth / itemCount;

    const tl2 = gsap.timeline({
      scrollTrigger: {
        trigger: grid,
        start: "top 110%", // when top of grid hits 80% of viewport
        toggleActions: "play none none none", // play only once
      },
    });

    // Create the line animation (as a fake element)
    if (isMobile) {
      // Mobile: Animate height (vertical line)
      const gridHeight = grid.offsetHeight;
      tl2.to(grid, {
        "--line-height": gridHeight,
        duration: 6,
        ease: "power1.inOut",
        onUpdate: function () {
          const progress = gsap.getProperty(grid, "--line-height");
          grid.style.setProperty("--after-height", progress + "px");
        },
      });
    } else {
      // Desktop: Animate width (horizontal line)
      const gridWidth = grid.offsetWidth;
      tl2.to(grid, {
        "--line-width": gridWidth,
        duration: 6,
        ease: "power1.inOut",
        onUpdate: function () {
          const progress = gsap.getProperty(grid, "--line-width");
          grid.style.setProperty("--after-width", progress + "px");
        },
      });
    }

    // Step 2: Staggered border reveals
    items.forEach((item, index) => {
      tl2.to(
        item,
        {
          onStart: () => {
            item.style.setProperty("--border-scale", "1");
            gsap.to(item.querySelector("::after"), {
              scale: 1,
              duration: 6,
              ease: "power1.inOut",
              transformOrigin: "center center",
            });
          },
        },
        2 + index * 0.95
      ); // Delay for stagger
    });
  }

  const video = document.querySelector(".video-background");
  if (video) {
    let src = video.currentSrc || video.src;
    console.log(video, src);

    /* Make sure the video is 'activated' on iOS */
    function once(el, event, fn, opts) {
      var onceFn = function (e) {
        el.removeEventListener(event, onceFn);
        fn.apply(this, arguments);
      };
      el.addEventListener(event, onceFn, opts);
      return onceFn;
    }

    once(document.documentElement, "touchstart", function (e) {
      video.play();
      video.pause();
    });

    /* ---------------------------------- */
    /* Scroll Control! */

    let tl = gsap.timeline({
      defaults: { duration: 1 },
      scrollTrigger: {
        trigger: ".ht_video_banner",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
      },
    });

    once(video, "loadedmetadata", () => {
      tl.fromTo(
        video,
        {
          currentTime: 0,
        },
        {
          currentTime: video.duration || 1,
        }
      );
    });

    /* When first coded, the Blobbing was important to ensure the browser wasn't dropping previously played segments, but it doesn't seem to be a problem now. Possibly based on memory availability? */
    setTimeout(function () {
      if (window["fetch"]) {
        fetch(src)
          .then((response) => response.blob())
          .then((response) => {
            var blobURL = URL.createObjectURL(response);

            var t = video.currentTime;
            once(document.documentElement, "touchstart", function (e) {
              video.play();
              video.pause();
            });

            video.setAttribute("src", blobURL);
            video.currentTime = t + 0.01;
          });
      }
    }, 1000);
  }

  // Show blog timing instead of date eg. 2 hours ago
  function timeAgo(dateStr) {
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now - date;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr / 24);

    if (diffHr < 1) return `${diffMin} minutes ago`;
    else if (diffDay < 1) return `${diffHr} hours ago`;
    else return `${diffDay} days ago`;
  }

  // Detect if current page is homepage
  const isHomePage =
    window.location.pathname === "/" ||
    window.location.pathname === "/index.html";

  // Define SVGs
  const homeSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none" style="vertical-align:middle; margin: 0 4px;">
    <circle cx="2.5" cy="3" r="2.5" fill="#674230"/>
  </svg>
`;

  const otherSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="4" height="5" viewBox="0 0 4 5" fill="none">
<circle cx="2" cy="2.5" r="2" fill="#8C734B"/>
</svg>
`;

  document.querySelectorAll(".ht_home_blogs_published_date").forEach((el) => {
    const dateStr = el.dataset.date;
    const ago = timeAgo(dateStr);
    const svg = isHomePage ? homeSvg : otherSvg;
    el.innerHTML = `${el.innerHTML} ${svg} ${ago}`;
  });

  document.querySelectorAll(".ht_account_tab_heading").forEach((button) => {
    const tabId = button.getAttribute("data-tab");
    if (!tabId) return;
    button.addEventListener("click", () => {
      const tabId = button.getAttribute("data-tab");

      // Remove active class from all buttons
      document
        .querySelectorAll(".ht_account_tab_heading")
        .forEach((btn) => btn.classList.remove("active"));
      // Add active class to clicked button
      button.classList.add("active");

      // Hide all tab contents
      document
        .querySelectorAll(".ht_account_tab_content")
        .forEach((tab) => tab.classList.remove("active"));
      // Show the matching content
      document.getElementById(tabId).classList.add("active");
    });
  });

  if (window.location.hash === "#ht_personal") {
    const personalTabButton = document.querySelector(
      '.ht_account_tab_heading[data-tab="ht_personal_tab"]'
    );
    if (personalTabButton) {
      personalTabButton.click();
    }
  }

  // Select the <details> element inside .ht_header_search
  // const searchDetails = document.querySelector('.ht_header_search > details');
  // const searchIcon = document.querySelector('.header__icon--search');
  // const searchScrollable = document.querySelector('.ht_header_search .predictive-search');

  // function disableScroll(e) {
  //   if (!searchScrollable.contains(e.target)) {
  //     e.preventDefault();
  //   }
  // }

  // function lockBodyScroll() {
  //   window.addEventListener('wheel', disableScroll, { passive: false });
  //   window.addEventListener('touchmove', disableScroll, { passive: false });
  // }

  // function unlockBodyScroll() {
  //   window.removeEventListener('wheel', disableScroll, { passive: false });
  //   window.removeEventListener('touchmove', disableScroll, { passive: false });
  // }

  // searchIcon.addEventListener('click', function () {
  //   // Wait for <details> to toggle before checking
  //   setTimeout(() => {
  //     if (searchDetails.hasAttribute('open')) {
  //       lockBodyScroll();
  //     } else {
  //       unlockBodyScroll();
  //     }
  //   }, 0); // Runs after <details> changes state
  // });

  const searchIcon = document.querySelector(".header__icon--search");
  searchIcon.addEventListener("click", function () {
    setTimeout(() => {
      document
        .querySelector(".section-header")
        ?.classList.remove("shopify-section-header-hidden");
    }, 0);
  });

  document.querySelectorAll(".cart-remove-button").forEach((button) => {
    button.addEventListener("click", function () {
      this.closest(".ht_remove_cart_item").classList.add("active");
    });
  });

  document.querySelectorAll(".cancel_remove_cart_item").forEach((button) => {
    button.addEventListener("click", function () {
      this.closest(".ht_remove_cart_item").classList.remove("active");
    });
  });

  const ht_login_register = document.querySelector(".ht_login_register");

  // Check for recover link
  const recoverLink = document.querySelector('.login a[href="#recover"]');
  if (recoverLink && ht_login_register) {
    recoverLink.addEventListener("click", () => {
      ht_login_register.classList.add("active");
    });
  }

  // Auto open recover if hash in URL
  if (ht_login_register && window.location.hash === "#recover") {
    ht_login_register.classList.add("active");
  }

  // Check for login link
  const loginLink = document.querySelector('.login a[href="#login"]');
  if (loginLink && ht_login_register) {
    loginLink.addEventListener("click", () => {
      ht_login_register.classList.remove("active");
    });
  }

  const recoverEmail = document.getElementById("RecoverEmail");
  const ht_recover_password = document.querySelector(".ht_recover_password");

  if (recoverEmail) {
    recoverEmail.addEventListener("input", function () {
      if (this.value.trim() !== "") {
        ht_recover_password.classList.add("active");
      } else {
        ht_recover_password.classList.remove("active");
      }
    });
  }

  const ht_banner_content = document.querySelector(".ht_banner_content");
  if (ht_banner_content) {
    gsap.to(
      ht_banner_content,
      {
        opacity: 1,
        y: 0,
        duration: 2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".ht_banner_content",
          start: "top 80%",
        },
      }
    );
  }

  gsap.to(".ht_cloud_bg_main_bottom img", {
    x: 80,
    opacity: 0,
    duration: 3,
    ease: "power2.out"
  });

  gsap.to(".banner_desktop", {
    x: -15,
    duration: 2,
    ease: "power2.out"
  });

});

// Initial animation for first slide on load
window.addEventListener("load", function () {
  let activeSlides = document.querySelectorAll(
    ".ht_product_taste_texture_content_swiper .swiper-slide-active .ht_product_taste_texture_content_slide, " +
      ".ht_product_taste_texture_content_swiper .swiper-slide-duplicate-active .ht_product_taste_texture_content_slide"
  );

  if (activeSlides) {
    // Ensure starting state is set
    gsap.set(activeSlides, {
      y: 80,
      opacity: 0,
    });

    // Animate in
    gsap.to(activeSlides, {
      duration: 0.4,
      y: 0,
      opacity: 1,
      ease: "power2.out",
      stagger: 0.1,
    });
  }
});
